import Action from '../Action'
import './styles/ModalCreateCis.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import { lang } from '../generales/traduction';
import { capitalizeFirstLetter } from '../../utils/utils';
import Modal from "react-modal";
import ModalLinKHost from "./ModalLinKHost";
const hostListModalSyncStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const ModalCreateCis =({user,languaje,cisSelected,  setCisSelected,handleShowPopup,mode,devices,server,setRegisterIsValid,dataCis,setData,loading,setLoading,setError,setEditActive,editActive,closCreateCisModal})=>{
    const obtenerFechaActualLocal = () => {
        const ahora = new Date();
        const anio = ahora.getFullYear();
        const mes = String(ahora.getMonth() + 1).padStart(2, '0'); // El mes se cuenta desde 0
        const dia = String(ahora.getDate()).padStart(2, '0');
        const horas = String(ahora.getHours()).padStart(2, '0');
        const minutos = String(ahora.getMinutes()).padStart(2, '0');
      
        return `${anio}-${mes}-${dia}T${horas}:${minutos}`;
      };
    const [loadingM,setLoadingM]=useState(false);
    const [IpValid,setIpValid]=useState(true)
    const [matchPassword,setMatchPassword]=useState(false)
    const [disabled,setDisabled]=useState(true)
    const [host,sethost]=useState([])
    // console.log(dataCis)
    const [poolRows2,setPoolRows2]=useState([]);
    const [cisData,setCisData]=useState({
        ip:(editActive)?dataCis.ip:"",
        hostid:(editActive)?dataCis.hostid:null,
        ci_group_id:(editActive)?dataCis.ci_group_id:null,
        name:(editActive)?dataCis.name:"",
        affiliation:(editActive)?dataCis.affiliation:"",
        description:(editActive)?dataCis.description:"",
        location_id:(editActive)?dataCis.location_id:null,
        service_id:(editActive)?dataCis.service_id:null,
        brand_id:(editActive)?dataCis.brand_id:null,
        model_id:(editActive)?dataCis.model_id:null,
        version:(editActive)?dataCis.version:"",
        serial_no:(editActive)?dataCis.serial_no:"",
        mac:(editActive)?dataCis.mac:"",   
        request_user:(dataCis.request_user)?dataCis.request_user:"",
        auth_user:(dataCis.auth_user)?dataCis.auth_user:"",
        user_comment:(dataCis.user_comment)?dataCis.user_comment:"",
    })
    const [hostName,setHostName]=useState("") 
    const [hostLocation,setHostLocation]=useState("") 
    const [hostActivate,setHostActivate]=useState(0)
    // console.log(cisData)
    const services_catalog=useFetch('cassia/cis_v2/services_catalog','','','GET',server)
    const groups_catalog=useFetch('cassia/cis_v2/groups','','','GET',server)
    const location_catalog=useFetch('zabbix/groups/municipios','','','GET',server)
    const brands_catalog=useFetch('cassia/brands','','','GET',server)
    const [hostsListSyncModalOpen, setHostsListSyncModalOpen] =useState(false);
    const [dataModels,setDataModels]=useState({
        data: [],
        loading: true,
        error: null})
    const [msgError,setMsgError]=useState("")
    const [listSearchIP,setListSearchIP]=useState(false)
    const [cisSelectedAux, setCisSelectedAux] = useState([]);
    // console.log(cisSelectedAux)
    function openHostsListSyncModal() {
//    setCisSelectedAux(elemento);
    setHostsListSyncModalOpen(true);
  }

  function closHostsListSyncModal() {
    
    setHostsListSyncModalOpen(false);
  }
    useEffect(()=>{
            if(cisData.brand_id!=0){
              search_marcas(cisData.brand_id)
            }
            
          },[cisData.brand_id])
          const search_marcas = (brand_id) => {
            // setLoadingCis(true)
            setDataModels({
              data: dataModels.data,
              loading: true,
              error: null})
            const fetchDataPost = async () => {
              try {
                  const response = await fetch(
                    server.url +
                      "/api/v1/cassia/host_models/by_brand/"+brand_id,
                    {
                      method: "GET",
                      headers: {
                        "Content-Type": "application/json",
                        accept: "application/json",
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                      },
                    }
                  );
                  if (response.ok) {
                      const data1 = await response.json();
                      // setDataModels(data1);
                      setDataModels({
                        data: data1,
                        loading: false,
                        error: null})
                      // setCreateCisModalOpen(true)
                  } else {
                      const data1 = await response.json();
                      throw new Error("Error en la solicitud");
                  }
              } catch (error) {
                console.error(error);
              }
            };
        
            fetchDataPost();
          };
    //     console.log(host)
        useEffect(()=>{
        //    console.log("cambio host")
        //    console.log(host[0])
           if(host.length>=1){
               setHostName(host[0].name)
               setHostLocation(host[0].location)
               setHostActivate(host[0].status)
               setCisData((prevState)=>{
                   return {
                       ...prevState,
                       ['location']:host[0].location
                   }
                   
               })
               // setCisData((prevState)=>{
               //     return {
               //         ...prevState,
               //         ['hostid']:host[0].hostid
               //     }

               // })
               // setCisData((prevState)=>{
               //     return {
               //         ...prevState,
               //         ['status']:(host[0].status!=0)?capitalizeFirstLetter(lang[languaje]['activo']):capitalizeFirstLetter(lang[languaje]['inactivo'])
               //     }

               // })
           }else{
               setHostName("")
               // setCisData((prevState)=>{
               //     return {
               //         ...prevState,
               //         ['hostid']:0
               //     }

               // })
               // setCisData((prevState)=>{
               //     return {
               //         ...prevState,
               //         ['device_name']:""
               //     }

               // })
           }
      },[host])
      
    const handleChange=(e)=>{
        const {name,value}=e.target
        if(e.target.name==="criticality"){
            setCisData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value===""?0:(parseInt(value))
                }
                
            })
        }  else if(e.target.name==="status"){
            setCisData((prevState)=>{
                return {
                    ...prevState,
                    [name]:(value=="Inactivo")?capitalizeFirstLetter(lang[languaje]['activo']):capitalizeFirstLetter(lang[languaje]['inactivo'])
                }
                
            })
        }else{
            setCisData((prevState)=>{
                return {
                    ...prevState,
                    [name]:value
                }
                
            })
        }



        if(e.target.name==="ip"){
            if(value==""){
                setHostLocation("")
                setHostActivate(0)
                setIpValid(true)
                sethost([])
                setHostName("")
                setHostLocation("")
            }else{
                setIpValid(validateIp(value))
            }
           
           
          }
    }

      useEffect(()=>{
       
            if( cisData.affiliation=="" || cisData.user_comment=="" || cisData.user_comment.length<4 || cisData.name=="" ){
                setDisabled(true)
            }else{
                setDisabled(false)
            }
      },[cisData])

      
      const Registrar=()=>{
          delete cisData.ip;
          let method='POST'
          let url_add=''
          if(editActive){
              method='PUT'
              url_add=dataCis.id
          }

          setLoading(true)
          const fetchDataPost = async () => {
            
         try {
             // console.log(localStorage.getItem('access_token'))
             const response = await fetch(server.url+'/api/v1/cassia/cis_v2/'+url_add, {
               method: method,  
               headers: {
                   'Content-Type': 'application/json',
                   Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                 },
               body: JSON.stringify(cisData),
             });
             if (response.ok) {
               
               const data1 = await response.json();
               setLoading(false)
               // Manejo de la respuesta
               setData(data1)
               // console.log(data1);
               closCreateCisModal()
             setRegisterIsValid(true)
             handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter(((editActive)?lang[languaje]['regEditCorr']:lang[languaje]['regGenCorr'])),'', true)
             const timer = setTimeout(() => {
               setRegisterIsValid(false)
               setEditActive(false)
               closCreateCisModal()
             }, 3000);
           
             } else {
               const data1 = await response.json();
               handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
               throw new Error('Error en la solicitud');
             }
         } catch (error) {
                setHostName("")
                setCisData({ip:"",hostid:0,date:"",responsible_name:"",auth_name:"",device_description:"",justification:"",previous_state:"",new_state:"",impact:"",result:"",observations:"",files:[],status:'Activo'})
                handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
            setLoading(false)
              // Manejo de errores
              setError(error)
              closCreateCisModal()
              setRegisterIsValid(true)
              
              const timer = setTimeout(() => {
                setRegisterIsValid(false)
                setEditActive(false)
                closCreateCisModal()
              }, 3000);
              console.error(error);
            }
          };

          fetchDataPost();
      }
    useEffect(()=>{
        if(editActive){
            buscar_host(dataCis.ip)
        }
    },[])
    const buscar_host=(ip)=>{
        setLoadingM(true)
        const fetchDataPost = async () => {
          
       try {
           const response = await fetch(server.url+'/api/v1/cassia/ci_elements/search_host/'+ip, {
               method: 'GET',  
               headers: {
                 'Content-Type': 'application/json',
                 'accept': 'application/json',
                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
               },
             });
           //   console.log(response)
           if (response.ok) {
               const data1 = await response.json();
               setLoadingM(false)
               if(data1.data.length==0){
                   sethost([])
               setHostName("")
               setHostLocation("")
               setHostActivate(0)
                   setMsgError(capitalizeFirstLetter(lang[languaje]['msgIpNoExiste']))
                   setIpValid(false)
               }else{
                   setIpValid(true)

               }
               sethost(data1.data)
               setDisabled(true)
           } else {
               const data1 = await response.json();
               throw new Error('Error en la solicitud');
           }
       } catch (error) {
            console.error(error);
          }
        };

        fetchDataPost();
    }
    const changeOption=(option,index)=>{
        const indexes={'groups_catalog':'ci_group_id',
            'services_catalog':'service_id',
            'Municipio':'location_id',
            'Marcas':'brand_id',
            'hostModel':'model_id'}
        setCisData((prevState)=>{
            return {
                ...prevState,
                [indexes[option.filter]]:option.value===""?0:(parseInt(option.value))
            }
            
        })
        // setCisRelation(option.value)
    }
    const [fecha, setDate] = useState('2023-09-28')
    const validateIp= (ip) => {
        const ipRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        let result = ipRegex.test(ip);
        if(result){
            buscar_host(ip)
        }else{
            setHostLocation("")
            setMsgError(capitalizeFirstLetter(lang[languaje]['ipNoValida']))
            sethost([])
                setHostName("")
                setHostLocation("")
                setHostActivate(0)
        }
        return result;
    };
      const [resultList,setResultList]=useState([])
      const handleSearchHost=(e)=>{
        
        const term = e.target.value;
        const {name,value}=e.target
        if(name=="ip"){
            setCisData((prevState)=>{
                return {
                    ...prevState,
                    ['ip']:value
                }
                
            })
        }
        // console.log(value)
        // setInputIP(value)
        setIpValid(validateIp(value))
        
        const filteredResults = devices.data.hosts.filter((item) => {
            
            return Object.entries(item).some(([key, value]) => {
              if (key === 'ip' || key=== 'Host') {
                return String(value).toLowerCase().includes(term.toLowerCase());
              }
              return false; // Si no es el atributo 'ip', retorna falso para continuar buscando en otros atributos
            });
          });
       
          setResultList(filteredResults)
      }
      
    //   console.log(resultList)
    const handleSelected=(element)=>{
        setIpValid(validateIp(element.ip))
        setCisData((prevState)=>{
            return {
                ...prevState,
                ['ip']:element.ip
            }
            
        })
        setCisData((prevState)=>{
                return {
                    ...prevState,
                    ['location_id']:element.groupid
                }
                
            })
        setListSearchIP(false)
    }
    const closeListSearch=()=>{
        setListSearchIP(false)
    }
    const handleTextAreaChange = (event) => {
        setCisData((prevState)=>{
            return {
                ...prevState,
                ['user_comment']:event.target.value
            }
            
        })
      };
      const reqField=()=>{
    return(
      <p className='reqField-gs'>
        *
      </p>
    )
  }
    const {ip,name,
  affiliation,
  description,
  hostid,
  ci_group_id,
  service_id,
  location_id,
  brand_id,
  model_id,
  version,
  mac,
  serial_no,
  request_user,user_comment,
  auth_user}=cisData;
    return(
        <>
        <div className="modal-user-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {((editActive)?lang[languaje]['editar'].toUpperCase():lang[languaje]['crear'].toUpperCase())+' '+lang[languaje]['registroConfiguracion'].toUpperCase()}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                        <div className="user-box-GS" style={{height:'10%'}}>
                                        {
                                           
                                            <Action disabled={false} origen='Cielo' titulo={(hostid==0|| hostid==null)?capitalizeFirstLetter(lang[languaje]['vincular']):'Cambiar/desvincular'}  action={openHostsListSyncModal}/>
                                            
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                     <div className="user-box-GS" style={{height:'10%'}}>
                                    <input   name="name"   type="text" value={name}
                                    onChange={handleChange} />
                                        <label className='label-GS active' style={{top: '-25%'}}>{capitalizeFirstLetter(lang[languaje]['nombre'])}{(name=="")?reqField():''}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                     <div className="user-box-GS" style={{height:'10%'}}>
                                    <input   name="affiliation"    type="text" value={affiliation}
                                    onChange={handleChange} />
                                        <label className='label-GS active' style={{top: '-25%'}}>{"Afiliacion"}{(affiliation=="")?reqField():''}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                    <input  name="description"    placeholder='Vincule un dispositivo' type="text" value={(hostid==0)?'':(cisSelectedAux.length==0?description:cisSelectedAux.host)}
                                    onChange={handleChange} />
                                        <label className='label-GS' style={{top: '-25%'}}>{capitalizeFirstLetter(lang[languaje]['descripcion'])}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                                            
                                                        
                                                        <input  name="ip"   placeholder='Vincule un dispositivo' type="text" value={(hostid==0)?'':(cisSelectedAux.length==0?ip:cisSelectedAux.agent_ip)}
                                                        onChange={handleSearchHost} onFocus={()=>{setListSearchIP(true)}} onBlur={()=>{setListSearchIP(true)}} />
                                                        
                                                            <label className='label-GS active' style={{top: '-25%'}}>Host IP</label>
                                                            {
                                                                IpValid?'':<span className='form-msg-error'> {msgError}</span>
                                                            }
                                                            
                                    </div>
                                    
                                    {/* <div className="user-box-GS" style={{height:'10%'}}>
                                    <input required name="hostid" style={{background: "#dddddda8"}} placeholder='Vincule un dispositivo' type="text" value={(hostid==0)?'':hostName}
                                    onChange={handleChange} disabled />
                                        <label className='label-GS active ' style={{top: '-25%'}}>Host name</label>
                                        
                                    </div> */}
                                   
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                        {
                                            (groups_catalog.loading)?'. . .':
                                            <SelectorAdmin placeholder={'Seleccionar tecnología...'} opGeneral={true} txtOpGen={''}  opt_de={ci_group_id} origen={'Admin'} data={groups_catalog.data.data} loading={groups_catalog.loading}  titulo='groups_catalog' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                    {/* <input required name="technology"  type="text" value={technology}
                                    onChange={handleChange} />*/}
                                        <label className='label-GS' style={{height:'10%'}}>{capitalizeFirstLetter(lang[languaje]['grupo'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                        {
                                            (services_catalog.loading)?'. . .':
                                            <SelectorAdmin placeholder={'Seleccionar tecnología...'} opGeneral={true} txtOpGen={''}  opt_de={service_id} origen={'Admin'} data={services_catalog.data.data} loading={services_catalog.loading}  titulo='services_catalog' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                    {/* <input required name="technology"  type="text" value={technology}
                                    onChange={handleChange} />*/}
                                        <label className='label-GS' style={{height:'10%'}}>{"Servicio"}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    {/* {(hostid!==0 && hostid!== '')?<div className="user-box-GS" style={{height:'10%'}}>
                                    <input  required name="device_name" style={{background: "#dddddda8"}}   className='read' type="text" value={hostLocation}
                                    onChange={handleChange} />
                                        <label className='label-GS active' style={{top: '-25%'}}>{capitalizeFirstLetter(lang[languaje]['ubicacion'])}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>: */}
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                        {
                                            (location_catalog.loading)?'. . .':
                                            <SelectorAdmin placeholder={'Seleccionar tecnología...'} opGeneral={true} txtOpGen={''}  opt_de={location_id} origen={'Admin'} data={location_catalog.data.data} loading={location_catalog.loading}  titulo='Municipio' selectFunction={changeOption} index={0}></SelectorAdmin>

                                        }
                                   
                                        <label className='label-GS' style={{height:'10%'}}>{capitalizeFirstLetter(lang[languaje]['ubicacion'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                        {
                                            (brands_catalog.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(brand_id==null)?0:brand_id} origen={'Admin'} data={brands_catalog.data.data}   loading={brands_catalog.loading}  titulo='Marcas' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                    {/* <input required name="technology"  type="text" value={technology}
                                    onChange={handleChange} />*/}
                                        <label className='label-GS' style={{height:'10%'}}>{capitalizeFirstLetter(lang[languaje]['marca'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                        {
                                            (dataModels.loading)?<p style={{color:'var(--txt-color)'}}> seleccione una marca. . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(model_id==null)?0:model_id} origen={'Admin'} data={dataModels.data.data}   loading={dataModels.loading}  titulo='hostModel' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                   
                                        <label className='label-GS' style={{height:'10%'}}>{capitalizeFirstLetter(lang[languaje]['modelo'])}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                    {/* <input required name="date"  type="datetime-local" value={date}
                                    onChange={handleChange} />
                                        <label className='label-cis active' >Fecha de ejecución</label> */}
                                        <input required name="version"  type="text" value={version}
                                    onChange={handleChange}  />
                                        <label className='label-GS  ' style={{top: '-25%'}}>{capitalizeFirstLetter(lang[languaje]['version'])}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                    {/* <input required name="date"  type="datetime-local" value={date}
                                    onChange={handleChange} />
                                        <label className='label-cis active' >Fecha de ejecución</label> */}
                                        <input required name="serial_no"  type="text" value={serial_no}
                                    onChange={handleChange}  />
                                        <label className='label-GS  ' style={{top: '-25%'}}>{"No. Serlial"}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                    {/* <input required name="date"  type="datetime-local" value={date}
                                    onChange={handleChange} />
                                        <label className='label-cis active' >Fecha de ejecución</label> */}
                                        <input required name="mac"  type="text" value={mac}
                                    onChange={handleChange}  />
                                        <label className='label-GS  ' style={{top: '-25%'}}>{"Mac address"}</label>
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                     <div className="user-box-GS" style={{height:'10%'}}>
                                        
                                    <input  name="request_user"  type="text" value={request_user}
                                    onChange={handleChange} />
                                        <label className='label-GS' style={{height:'10%'}}>{"Solicitante"}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                     <div className="user-box-GS" style={{height:'10%'}}>
                                       
                                    <input  name="auth_user"  type="text" value={auth_user}
                                    onChange={handleChange} />
                                        <label className='label-GS' style={{height:'10%'}}>{"Autorizador"}</label> 
                                        {
                                            // (name==="" || nombreIsValid)?'':<span className='form-msg-error'> Nombre no valido</span>
                                        }
                                        
                                    </div>
                                    <div className="user-box-GS" style={{height:'30%'}}>
                
                  <textarea maxlength="2000" style={{background:'background: var(--white-color)',position:'relative',resize:'none',width:'100%'}} id="nota" name="nota" className="CmtAuth" rows="5" cols="15" value={user_comment}  onChange={handleTextAreaChange}></textarea>
                                        <label className='label-GS' style={{top:'5%'}}>{'Comentarios'}{(user_comment==""|| user_comment.length<4)?reqField():''}</label> 
                                <label className='label-GS' style={{top:'5%', left:'20%',color:'var(--txt-color)'}}>{'(minmo 3 caracteres)'}</label> 
                                </div>
                                    
                                  
                                    
                                    <div className="user-box-GS" style={{height:'10%'}}>
                                        {
                                            (loading)?<LoadSimple></LoadSimple>
                                            :
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                            <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                            </>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
        <Modal
        isOpen={hostsListSyncModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListSyncModal}
        style={hostListModalSyncStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalLinKHost cisData={cisData}  editActive={editActive}setCisData={setCisData} poolRows={poolRows2} setCisSelectedAux={setCisSelectedAux} server={server} handleShowPopup={handleShowPopup}  cisSelectRow={cisSelectedAux} setPoolRows={setPoolRows2} languaje={languaje}  mode={mode} closeAddHostModal={closHostsListSyncModal}  ></ModalLinKHost>
    </Modal>
    </>
    )
}

export default ModalCreateCis